import logo from "./logo.svg";
import "./App.css";
import { useEffect, useRef, useState } from "react";
import videojs from "video.js";
import { Cursor } from "react-creative-cursor";
import "react-creative-cursor/dist/styles.css";
import Video from "./components/video";
import { generate3dPhoto } from "pixi-3d-photo";
import Plyr from "plyr-react";
import "plyr-react/plyr.css";
import Header from "./components/header";
import Loading from "./components/loading";
import { useMediaQuery } from "react-responsive";
import HeaderMobile from "./components/headerMobile";

function App() {
  const playerRef = useRef(null);
  const [loadProgress, setLoadProgress] = useState(0);
  const isMobile = useMediaQuery({
    query: "(max-width: 1024px)",
  });

  useEffect(() => {
    if (!isMobile) {
      let svgString = `<svg shape="play" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path class="di-an di-an1" d="M7 4L28 16L7 28V4Z" />
      <path class="di-an di-an2" d="M25 4L4 16L25 28V4Z" />
      </svg>
      `;
      const parser = new DOMParser();
      let doc = parser.parseFromString(svgString, "text/html");

      let svg = doc.querySelector("svg");

      let innerCursor = document.querySelector("#c-cursorInner");
      innerCursor.appendChild(svg);
    }
  }, [isMobile]);



  const animate = (ctnElement, direction = "forward") => {
    let headerCtn = document.querySelector(".header-ctn");
    if (direction === "forward") {
      ctnElement.classList.add("forward");
    } else if (direction === "reverse") {
      ctnElement.classList.remove("forward");
    } else if (direction === "fade-in") {
      ctnElement.classList.add("forward");
      headerCtn.classList.add("fade-in");
    } else {
      ctnElement.classList.remove("forward");
      headerCtn.classList.remove("fade-in");
    }
  };

  const setLoadProgressState = () => {
    setLoadProgress((pre) => {
      if (Math.min(100, pre + 20) === 100) {
        document
          .querySelectorAll(".movie-list-line")[0]
          .classList.add("active");
          document.querySelector('body').style.overflowY = 'auto'
      }
      return Math.min(100, pre + 20);
    });
  };

  useEffect(() => {
    let timeOut = setTimeout(() => {
      document.querySelector('body').style.overflowY = 'auto'
      setLoadProgress(100)
      clearTimeout(timeOut)
    },6000)



    return () => clearTimeout(timeOut)
  },[])


  const forceLoad = () => {
    let index = 0;
      let interval = setInterval(() => {
        setLoadProgressState();
        index++
        console.log('interval')
        if(index >= 5) {
          clearInterval(interval)
        }
      }, 200);

  };

  const handlePlayToggle = (shape) => {
    if(!isMobile) {
      const svg = document.querySelector("#c-cursorInner > svg");
      let attribute;
      console.log(shape);
      if (!shape) {
        console.log("la");
        attribute = svg.getAttribute("shape") === "play" ? "pause" : "play";
      } else {
        attribute = shape;
      }
  
      svg.setAttribute("shape", attribute);
    }

  };

  const handlePlayVisble = () => {
    if(!isMobile) {
      const svg = document.querySelector("#c-cursorInner > svg");
      console.log(svg);
      svg.classList.add("active");
    }

  };

  const handlePlayHidden = () => {
    if(!isMobile) {
      const svg = document.querySelector("#c-cursorInner > svg");
      svg.classList.remove("active");
      console.log("hidden");
    }

  };

  console.log("重新渲染");
  return (
    <div className="App">
      <Loading loadProgress={loadProgress} />
      <main>
        {isMobile ? (
          <HeaderMobile
            handlePlayToggle={handlePlayToggle}
            handlePlayVisble={handlePlayVisble}
            handlePlayHidden={handlePlayHidden}
            setLoadProgressState={setLoadProgressState}
            isMobile={isMobile}
          />
        ) : (
          <>
            <Cursor
              magneticAnimationAmount={0.3}
              magneticAnimationDuration={1.2}
              // stickAnimationAmount={0.09}
              cursorSize={24}
            />

            <Header
              handlePlayToggle={handlePlayToggle}
              handlePlayVisble={handlePlayVisble}
              handlePlayHidden={handlePlayHidden}
              setLoadProgressState={setLoadProgressState}
              isMobile={isMobile}
            />
          </>
        )}
      </main>
    </div>
  );
}

export default App;
